module.exports = __webpack_public_path__ + "static/horizons03-4d5c52106ca77560950c3ab9b9183ef8.png";